const writeCookie = (name, data, hasDomain, days) => {
  let expires = "";
  let domain = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = ";expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  if (hasDomain) {
    domain = ";domain=.emphasis.com";
  } else {
    domain = "";
  }
  document.cookie = name.toString() + "=" + data + ";path=/" + expires + domain;
};

export default writeCookie;
